export enum ExportSettingType {
  CUSTOM_MATERIAL_NUMBER = 'customer_material_number',
  DOCUMENT_TYPE = 'document_type',
  LANGUAGE = 'language',
  ORDER_NUMBER = 'order_number',
  ORDER_POSITION_NUMBER = 'order_position_number',
  ORDER_REFERENCE = 'order_reference',
  ORDER_CODE = 'order_code',
  SERIAL_NUMBER = 'serial_number',
  TAG = 'tag',
  ORIGINAL_FILENAME = 'original_filename',
  QUOTE_REFERENCE = 'quote_reference',
  QUOTE_NUMBER = 'quote_number',
  QUOTE_POSITION_NUMBER = 'quote_position_number',
}
